export default __webpack_public_path__ + "static/media/top100-logo.c640d84d.png";